export const VALUABLES = {
  nickname: 'PRODUCTS.VALUABLES.nickname',
  properties: [
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
    { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    { name: 'objectName', key: 'OBJECT_NAME', group: 'OBJECT_INFO' },
    { name: 'objectCategory', key: 'OBJECT_CATEGORY', group: 'OBJECT_INFO' },
  ],
  icon:'valuables'
};
